import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Link, useLocation, useHistory } from "react-router-dom"
import {
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
  Card,
  CardImg,
  CardTitle,
  Modal,
  Collapse,
} from "reactstrap"
import { Carousel } from "react-responsive-carousel"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import * as url from "helpers/url_helper"
import SweetAlert from "react-bootstrap-sweetalert"
import { cardSize } from "helpers/constants_helper"

//i18n
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"

// import images
import logodark from "../../assets/images/logo-dark.png"
import logolight from "../../assets/images/logo-light.png"
import bgImage from "assets/images/ugifts/loginbg.png"
import bgProfile from "assets/images/ugifts/profile_bg.png"
import iconCurrent from "assets/images/ugifts/icons/checkout/icon_step_current.png"
import iconDone from "assets/images/ugifts/icons/checkout/icon_step_done.png"
import iconIncomplete from "assets/images/ugifts/icons/checkout/icon_step_incomplete.png"
import iconEditable from "assets/images/ugifts/icons/icon_editable.png"
import placeholderCamera from "assets/images/ugifts/dummyCard/placeholder_camera.png"
import placeholderEmpty from "assets/images/ugifts/dummyCard/empty.png"
import dummyCard from "assets/images/ugifts/dummyCard/dummyCard.png"

import { Button } from "@material-ui/core"

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

function bin2hex(str) {
  undefined
  var ret = ""
  var r = /[0-9a-zA-Z_.~!*()]/
  for (var i = 0, l = str.length; i < l; i++) {
    undefined
    if (r.test(str.charAt(i))) {
      undefined
      ret += str.charCodeAt(i).toString(16)
    } else {
      undefined
      ret += encodeURIComponent(str.charAt(i)).replace(/%/g, "")
    }
  }
  return ret
}

function hex2bin(str) {
  undefined
  var ret = ""
  var tmp = ""
  for (var i = 0; i < str.length - 1; i += 2) {
    undefined
    var c = String.fromCharCode(parseInt(str.substr(i, 2), 16))
    if (c.charCodeAt() > 127) {
      undefined
      tmp += "%" + str.substr(i, 2)
      if (tmp.length == 9) {
        undefined
        ret += decodeURIComponent(tmp)
        tmp = ""
      }
    } else {
      undefined
      ret += c
    }
  }
  return ret
}

// const cardSize = { width: 686, height: 460 }
// const cardSize = { width: 1200, height: 800 }

const useAudio = url => {
  const [audio, setAudio] = useState(null)
  const [playing, setPlaying] = useState(false)

  const toggle = () => setPlaying(!playing)
  const updateAudio = url => {
    audio && audio.pause()
    setPlaying(false)
    setAudio(new Audio(url))
  }

  const playAudio = () => {
    audio && audio.play()
    setPlaying(true)
  }

  useEffect(() => {
    console.log(playing)
    audio && (playing ? audio.play() : audio.pause())
  }, [playing])

  useEffect(() => {
    console.log(audio)
    if (audio) {
      audio.addEventListener("ended", () => setPlaying(false))
      playAudio()
    }

    return () => {
      if (audio) {
        audio.removeEventListener("ended", () => setPlaying(false))
      }
    }
  }, [audio])

  return [playing, toggle, updateAudio]
}

const CheckoutConfirmation = props => {
  const query = useQuery()
  const history = useHistory()

  const [token, setToken] = useState(null)
  const [uid, setUid] = useState(null)
  const [quantity, setQuantity] = useState(0)
  const [playing, toggle, updateAudio] = useAudio()
  const [songSelected, setSongSelected] = useState(null)
  const [songPlaying, setSongPlaying] = useState(null)

  useEffect(() => {
    if (localStorage.getItem("authAPI")) {
      const obj = JSON.parse(localStorage.getItem("authAPI"))
      console.log(
        "storage",
        obj.api_token_expiry + " / " + Math.floor(Date.now() / 1000)
      )
      if (obj.api_token_expiry < Math.floor(Date.now() / 1000)) {
        getToken()
      } else {
        setToken(obj)
      }
    } else {
      getToken()
    }

    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      setUid(obj.member_id)
      console.log(obj)
    }

    if (localStorage.getItem("I18N_LANGUAGE")) {
      setLanguage(localStorage.getItem("I18N_LANGUAGE"))
    }
  }, [])

  const getToken = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "get_api_token")
    urlencoded.append("source", "web")
    urlencoded.append("api_key", process.env.REACT_APP_APIKEY)

    const requestOptions = {
      method: "POST",
      body: urlencoded,
    }

    console.log("Request token", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_POST_AUTH, requestOptions)
    const postresponse = await response.json()

    console.log(response.status, postresponse.message)

    if (response.status == 200 && postresponse.success) {
      setToken(postresponse)
      localStorage.setItem("authAPI", JSON.stringify(postresponse))
      console.log(response.status, token)
    } else {
      // seterror_alert(true)
    }
  }

  useEffect(() => {
    if (token != null) {
      getUserProfile()
      getBasketData()
      console.log("use effect")
    }
  }, [token])

  const [userData, setUserData] = useState(null)
  const getUserProfile = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_profile")
    urlencoded.append("member_id", uid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request category", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setUserData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const [basketData, setBasketData] = useState(null)
  const [giftcardId, setGiftcardId] = useState(null)
  const [giftEditableData, setGiftEditableData] = useState(null)
  const [giftAttachment, setGiftAttachment] = useState({})
  const getBasketData = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_basket")
    urlencoded.append("member_id", uid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request basket", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_BASKET,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setBasketData(postresponse.table)
      if (postresponse.table.giftcard_id) {
        setGiftcardId(postresponse.table.giftcard_id)
      }
    } else {
      // seterror_alert(true)
    }
  }

  useEffect(() => {
    if (token != null) {
      getGiftList()
      getMusicList()
    }
  }, [giftcardId])

  useEffect(() => {
    if (basketData) {
      var calculate = 0
      basketData.products.forEach(product => {
        calculate + parseInt(product.quantity)
      })
      setQuantity(calculate)
      localStorage.setItem("basketCount", calculate)
      if (basketData.giftcard_edit_parameter != "") {
        const download = JSON.parse(basketData.giftcard_edit_parameter)
        download
          .filter(data => {
            return data.type == "message" || data.type == "text"
          })
          .forEach(data => {
            data["content"] = new TextDecoder().decode(
              hexToBytes(data["content"])
            )
          })
        setGiftEditableData(download)
        console.log(download)
        // setGiftEditableData(JSON.parse(basketData.giftcard_edit_parameter))
        // console.log(JSON.parse(basketData.giftcard_edit_parameter))
      }
      // setGiftEditableData(dummyGift)
    }
  }, [basketData])

  const [giftData, setGiftData] = useState(null)
  const getGiftList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_giftcard")
    // urlencoded.append("order_by", sortType)
    urlencoded.append("giftcard_id", giftcardId)

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request giftcard product", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_GIFT, requestOptions)
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setGiftData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  useEffect(() => {
    console.log(giftAttachment)
  }, [giftAttachment])

  const [musicData, setMusicData] = useState(null)
  const getMusicList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "list_music")
    urlencoded.append("order_by", "asc")
    urlencoded.append("giftcard_id", giftcardId)

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request giftcard music", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_GIFT, requestOptions)
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setMusicData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  function ConvertStringToHex(str) {
    var arr = []
    for (var i = 0; i < str.length; i++) {
      arr[i] = ("00" + str.charCodeAt(i).toString(16)).slice(-4)
    }
    return "\\u" + arr.join("\\u")
  }

  function ConvertHexToString(str) {
    return unescape(str.replace(/\\/g, "%"))
  }

  function bytesToHex(bytes) {
    return Array.from(bytes, byte => byte.toString(16).padStart(2, "0")).join(
      ""
    )
  }

  function stringToUTF8Bytes(string) {
    return new TextEncoder().encode(string)
  }

  function hexToBytes(hex) {
    const bytes = new Uint8Array(hex.length / 2)
    for (let i = 0; i !== bytes.length; i++) {
      bytes[i] = parseInt(hex.substr(i * 2, 2), 16)
    }
    return bytes
  }

  const updateGiftCardEditable = async () => {
    const upload = [...giftEditableData]
    upload
      .filter(data => {
        return data.type == "message" || data.type == "text"
      })
      .forEach(data => {
        data["content"] = bytesToHex(stringToUTF8Bytes(data["content"]))
      })
    console.log("upload", upload)
    // const download = [...upload]
    // download
    //   .filter(data => {
    //     return data.type == "message" || data.type == "text"
    //   })
    //   .forEach(data => {
    //     data["content"] = new TextDecoder().decode(hexToBytes(data["content"]))
    //   })
    // console.log("download", download)
    // const a = JSON.stringify(giftEditableData)
    // try {
    //   const hexa = bytesToHex(stringToUTF8Bytes(a))
    //   console.log("before", hexa)
    //   const dehexa = new TextDecoder().decode(hexToBytes(hexa))
    //   const b = JSON.parse(dehexa)
    //   console.log("success", b)
    // } catch (e) {
    //   alert(e) // error in the above string (in this case, yes)!
    // }

    // return

    var urlencoded = new FormData()
    urlencoded.append("option", "giftcard_to_basket")
    urlencoded.append("member_id", uid)
    urlencoded.append("giftcard_id", giftcardId)
    urlencoded.append("giftcard_edit_parameter", JSON.stringify(upload))
    for (var k in giftAttachment) {
      urlencoded.append(k, giftAttachment[k])
    }

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request giftcard to basket", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_BASKET,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      // setBasketData(postresponse.table)
      history.push("/checkout-confirmation")
      // setsuccess_dlg(true)
      // setdynamic_title("Cart Updated")
      // setdynamic_description(postresponse.message)
    } else {
      seterror_alert(true)
      setdynamic_title(props.t("Cart Update Failed"))
      setdynamic_description(postresponse.message)
    }
  }

  const [selectedFile, setSelectedFile] = useState()
  const [isFilePicked, setIsFilePicked] = useState(false)
  const changeHandler = (e, key) => {
    console.log("change handler", e)
    if (e.target.files[0]) {
      setSelectedFile(e.target.files[0])
      setIsFilePicked(true)

      var reader = new FileReader()
      reader.onload = function (e) {
        document.getElementById("imgPreview-" + key).src = e.target.result
      }
      reader.readAsDataURL(e.target.files[0])

      setGiftAttachment({ ...giftAttachment, [key]: e.target.files[0] })

      var item = giftEditableData.find(value => value.key == key)
      var index = giftEditableData.findIndex(value => value.key == key)
      item["content"] = key
      const giftEditableDataUpdate = [...giftEditableData]
      giftEditableDataUpdate[index] = item
      setGiftEditableData(giftEditableDataUpdate)
    }
  }

  const textChangeHandler = (e, key) => {
    // console.log(key, e.target.value)
    var item = giftEditableData.find(value => value.key == key)
    var index = giftEditableData.findIndex(value => value.key == key)
    item["content"] = e.target.value
    const giftEditableDataUpdate = [...giftEditableData]
    giftEditableDataUpdate[index] = item
    setGiftEditableData(giftEditableDataUpdate)
  }

  useEffect(() => {
    if (songSelected) {
      var item = giftEditableData.find(value => value.key == "music")
      var index = giftEditableData.findIndex(value => value.key == "music")
      item["content"] = songSelected
      const giftEditableDataUpdate = [...giftEditableData]
      giftEditableDataUpdate[index] = item
      setGiftEditableData(giftEditableDataUpdate)
    }
  }, [songSelected])

  useEffect(() => {
    if (giftEditableData) {
      console.log(giftEditableData)
    }
  }, [giftEditableData])

  function handleClick(key) {
    console.log("click")
    document.getElementById("inputPhoto-" + key).click()
  }

  const [modal_song, setmodal_song] = useState(false)

  function tog_song() {
    setmodal_song(!modal_song)
    if (playing) toggle()
    removeBodyCss()
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  const [success_dlg, setsuccess_dlg] = useState(false)
  const [success_dlg_noaction, setsuccess_dlg_noaction] = useState(false)
  const [error_alert, seterror_alert] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")

  const [language, setLanguage] = useState("eng")

  const multiLanguageHandler = data => {
    switch (language) {
      case "eng":
        return data.en
      case "cn":
        return data.cn ? data.cn : data.en
      case "jp":
        return data.jp ? data.jp : data.en
      default:
        return data.en
    }
  }

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>Ugift</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            {success_dlg_noaction ? (
              <SweetAlert
                success
                title={dynamic_title}
                onConfirm={() => {
                  setsuccess_dlg_noaction(false)
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {success_dlg ? (
              <SweetAlert
                success
                title={dynamic_title}
                onConfirm={() => {
                  history.push("/checkout-confirmation")
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {error_alert ? (
              <SweetAlert
                title={dynamic_title}
                danger
                onConfirm={() => {
                  seterror_alert(false)
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            <Col
              xl={6}
              className="mx-auto"
              style={{
                maxWidth: "480px",
                backgroundColor: "white",
                // backgroundImage: `url(${bgImage})`,
                // backgroundSize: "cover",
              }}
            >
              {/* <img
                src={bgImage}
                alt=""
                style={{
                  position: "absolute",
                  objectFit: "contain",
                  maxWidth: "480px",
                }}
              /> */}
              <div
                className="auth-full-page-content"
                style={{
                  minHeight: "100vh",
                  paddingTop: "122px",
                  backgroundColor: "#F5F5F5",
                  paddingBottom: "92px",
                }}
              >
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <Row
                      className="m-0 w-100"
                      style={{
                        height: "56px",
                        backgroundColor: "#009FE2",
                        position: "fixed",
                        top: 0,
                        zIndex: 1030,
                        maxWidth: "480px",
                      }}
                    >
                      <Col xs={2} className="ps-0">
                        {/* <Link to="/categories"> */}
                        <Button
                          className="h-100 m-0"
                          onClick={() => {
                            history.goBack()
                          }}
                        >
                          <i className="bx bx-arrow-back align-middle font-size-20 text-white" />
                        </Button>
                        {/* </Link> */}
                      </Col>
                      <Col xs={8} className="align-self-center">
                        <p className="h-100 text-white font-size-15 my-auto text-center">
                          {props.t("Card Customisation")}
                        </p>
                      </Col>
                      <Col xs={2} className="pe-0">
                        {/* <Link to="#">
                          <Button className="h-100 m-0">
                            <i className="bx bx-basket align-middle font-size-28 text-white" />
                          </Button>
                        </Link> */}
                      </Col>
                    </Row>
                    <Row
                      className="m-0 w-100"
                      style={{
                        height: "66px",
                        position: "fixed",
                        top: 56,
                        zIndex: 1020,
                        maxWidth: "480px",
                      }}
                    >
                      <Col xs={4} className="p-0">
                        <div
                          className="w-100 h-100 m-0"
                          style={{
                            borderRadius: 0,
                            borderBottom: "5px",
                            borderBottomColor: "#4A4A4A",
                            borderBottomStyle: "solid",
                            backgroundColor: "white",
                            textTransform: "none",
                          }}
                        >
                          <Row>
                            <Col xs="auto" className="mx-auto">
                              <img
                                src={iconDone}
                                className="avatar-sm mt-2 mb-1"
                                alt=""
                                style={{ maxWidth: "20px", maxHeight: "20px" }}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col xs="auto" className="mx-auto">
                              <span
                                className="font-size-12"
                                style={{ color: "#4A4A4A" }}
                              >
                                {props.t("Card Selection")}
                              </span>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                      <Col xs={4} className="p-0">
                        <div
                          className="w-100 h-100 m-0"
                          style={{
                            borderRadius: 0,
                            borderBottom: "5px",
                            borderBottomColor: "#009FE2",
                            borderBottomStyle: "solid",
                            backgroundColor: "white",
                            textTransform: "none",
                          }}
                        >
                          <Row>
                            <Col xs="auto" className="mx-auto">
                              <img
                                src={iconCurrent}
                                className="avatar-sm mt-2 mb-1"
                                alt=""
                                style={{ maxWidth: "20px", maxHeight: "20px" }}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col xs="auto" className="mx-auto">
                              <span
                                className="font-size-12 text-primary"
                                // style={{ color: "#B1B1B1" }}
                              >
                                {props.t("Customisation")}
                              </span>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                      <Col xs={4} className="p-0">
                        <div
                          className="w-100 h-100 m-0"
                          style={{
                            borderRadius: 0,
                            borderBottom: "5px",
                            borderBottomColor: "#B1B1B1",
                            borderBottomStyle: "solid",
                            backgroundColor: "white",
                            textTransform: "none",
                          }}
                        >
                          <Row>
                            <Col xs="auto" className="mx-auto">
                              <img
                                src={iconIncomplete}
                                className="avatar-sm mt-2 mb-1"
                                alt=""
                                style={{ maxWidth: "20px", maxHeight: "20px" }}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col xs="auto" className="mx-auto">
                              <span
                                className="font-size-12"
                                style={{ color: "#B1B1B1" }}
                              >
                                {props.t("Order")}
                              </span>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Card
                          className="mb-3 p-3"
                          style={{
                            borderRadius: "0px",
                            // width: "160px",
                            // height: "196px",
                            backgroundColor: "white",
                          }}
                        >
                          <Card className="mb-0">
                            {giftData && (
                              <CardImg
                                top
                                className="img-fluid"
                                src={giftData.image}
                                alt=""
                                style={{
                                  aspectRatio: "3/2",
                                  // objectFit: "cover",
                                  borderRadius: "14px",
                                  zIndex: 500,
                                }}
                              />
                            )}
                            {giftEditableData &&
                              giftEditableData
                                .filter(data => {
                                  return data.type == "text"
                                })
                                .map((data, index) => (
                                  <Input
                                    type="textarea"
                                    className="form-control font-size-15 p-1"
                                    id={"textInput-" + data.key}
                                    name={data.key}
                                    placeholder={data.placeholder}
                                    value={data.content}
                                    style={{
                                      borderRadius: "4px",
                                      // border: "none",
                                      background: "none",
                                      position: "absolute",
                                      top: `calc(100% * ${
                                        data.ypos / cardSize.height
                                      })`,
                                      left: `calc(100% * ${
                                        data.xpos / cardSize.width
                                      })`,
                                      width: `calc(100% * ${
                                        data.width / cardSize.width
                                      })`,
                                      height: `calc(100% * ${
                                        data.height / cardSize.height
                                      })`,
                                      zIndex: 502,
                                      resize: "none",
                                      overflow: "hidden",
                                    }}
                                    onChange={e => {
                                      textChangeHandler(e, data.key)
                                    }}
                                    onKeyPress={e => {
                                      if (e.key === "Enter") e.preventDefault()
                                    }}
                                  />
                                ))}
                            {giftEditableData &&
                              giftEditableData
                                .filter(data => {
                                  return data.type == "image"
                                })
                                .map((data, index) =>
                                  giftAttachment[data.key] ? (
                                    <div>
                                      <img
                                        // src={data.placeholder}
                                        onClick={() => {
                                          handleClick(data.key)
                                        }}
                                        id={"imgPreview-" + data.key}
                                        name={data.key}
                                        style={{
                                          position: "absolute",
                                          top: `calc(100% * ${
                                            data.ypos / cardSize.height
                                          })`,
                                          left: `calc(100% * ${
                                            data.xpos / cardSize.width
                                          })`,
                                          width: `calc(100% * ${
                                            data.width / cardSize.width
                                          })`,
                                          height: `calc(100% * ${
                                            data.height / cardSize.height
                                          })`,
                                          // objectFit: "scale-down",
                                          objectFit: "cover",
                                          zIndex: 499,
                                        }}
                                      />
                                      <img
                                        onClick={() => {
                                          handleClick(data.key)
                                        }}
                                        src={placeholderEmpty}
                                        style={{
                                          position: "absolute",
                                          top: `calc(100% * ${
                                            data.ypos / cardSize.height
                                          })`,
                                          left: `calc(100% * ${
                                            data.xpos / cardSize.width
                                          })`,
                                          width: `calc(100% * ${
                                            data.width / cardSize.width
                                          })`,
                                          height: `calc(100% * ${
                                            data.height / cardSize.height
                                          })`,
                                          objectFit: "scale-down",
                                          zIndex: 501,
                                        }}
                                      />
                                      <Input
                                        type="file"
                                        className="form-control"
                                        id={"inputPhoto-" + data.key}
                                        accept="image/*"
                                        name={data.key}
                                        // aria-describedby="inputGroupFileAddon04"
                                        // aria-label="Upload"
                                        onChange={e => {
                                          changeHandler(e, data.key)
                                        }}
                                        hidden
                                      />
                                    </div>
                                  ) : (
                                    <div>
                                      <img
                                        onClick={() => {
                                          handleClick(data.key)
                                        }}
                                        src={
                                          data.content
                                            ? data.content
                                            : placeholderCamera
                                        }
                                        style={{
                                          position: "absolute",
                                          top: `calc(100% * ${
                                            data.ypos / cardSize.height
                                          })`,
                                          left: `calc(100% * ${
                                            data.xpos / cardSize.width
                                          })`,
                                          width: `calc(100% * ${
                                            data.width / cardSize.width
                                          })`,
                                          height: `calc(100% * ${
                                            data.height / cardSize.height
                                          })`,
                                          // objectFit: "scale-down",
                                          objectFit: "cover",
                                          zIndex: 499,
                                        }}
                                      />
                                      <img
                                        onClick={() => {
                                          handleClick(data.key)
                                        }}
                                        src={placeholderEmpty}
                                        style={{
                                          position: "absolute",
                                          top: `calc(100% * ${
                                            data.ypos / cardSize.height
                                          })`,
                                          left: `calc(100% * ${
                                            data.xpos / cardSize.width
                                          })`,
                                          width: `calc(100% * ${
                                            data.width / cardSize.width
                                          })`,
                                          height: `calc(100% * ${
                                            data.height / cardSize.height
                                          })`,
                                          objectFit: "scale-down",
                                          zIndex: 501,
                                        }}
                                      />
                                      <Input
                                        type="file"
                                        className="form-control"
                                        id={"inputPhoto-" + data.key}
                                        accept="image/*"
                                        name={data.key}
                                        // aria-describedby="inputGroupFileAddon04"
                                        // aria-label="Upload"
                                        onChange={e => {
                                          changeHandler(e, data.key)
                                        }}
                                        hidden
                                      />
                                    </div>
                                  )
                                )}
                          </Card>
                        </Card>
                      </Col>
                    </Row>
                    {/* <Row>
                      <Col>
                        <Card
                          className="mb-3 p-3"
                          style={{
                            borderRadius: "0px",
                            // width: "160px",
                            // height: "196px",
                            backgroundColor: "white",
                          }}
                        >
                          {giftData && (
                            <CardImg
                              top
                              className="img-fluid"
                              src={giftData.image}
                              alt=""
                              style={{
                                aspectRatio: "3/2",
                                objectFit: "cover",
                                borderRadius: "14px",
                              }}
                            />
                          )}
                        </Card>
                      </Col>
                    </Row> */}
                    {giftEditableData &&
                      giftEditableData
                        .filter(data => {
                          return data.type == "message"
                        })
                        .map((data, index) => (
                          <div>
                            <Row className="px-3 mb-2">
                              <Col>
                                <span
                                  className="mb-0 font-size-20"
                                  style={{
                                    fontWeight: 700,
                                  }}
                                >
                                  {props.t("Message")}
                                </span>
                              </Col>
                            </Row>
                            <Row className="mx-0 mb-3">
                              <Col className="px-3">
                                <Input
                                  type="textarea"
                                  className="form-control font-size-15 text-dark"
                                  id="message"
                                  name="message"
                                  placeholder={data.placeholder}
                                  value={data.content}
                                  style={{
                                    borderRadius: "4px",
                                    border: "none",
                                  }}
                                  onChange={e => {
                                    textChangeHandler(e, data.key)
                                  }}
                                  onKeyPress={e => {
                                    if (e.key === "Enter") e.preventDefault()
                                  }}
                                />
                              </Col>
                            </Row>
                          </div>
                        ))}
                    {giftEditableData &&
                      musicData &&
                      giftEditableData
                        .filter(data => {
                          return data.type == "music"
                        })
                        .map((data, index) => (
                          <Row className="m-0">
                            <Col>
                              <Row className="px-3">
                                <button
                                  className="btn btn-outline-light mt-0 font-size-18 bg-white text-dark"
                                  onClick={tog_song}
                                >
                                  <span className="align-middle">
                                    <i className="bx bx-volume-full align-middle font-size-22 me-2" />{" "}
                                    {data.content &&
                                    musicData.filter(
                                      value => value.id == data.content
                                    ).length > 0
                                      ? musicData.filter(
                                          value => value.id == data.content
                                        )[0].name
                                      : props.t("Add Music")}
                                  </span>
                                </button>
                              </Row>
                            </Col>
                          </Row>
                        ))}

                    <Row
                      className="m-0 w-100"
                      style={{
                        height: "76px",
                        backgroundColor: "#ffffff",
                        position: "fixed",
                        bottom: 0,
                        zIndex: 1030,
                        maxWidth: "480px",
                        boxShadow: "0 -0.75rem 1.5rem rgba(18, 38, 63, 0.03)",
                      }}
                    >
                      <Col className="h-100 p-0">
                        <Card body className="mb-0 p-3">
                          <Row>
                            <Col>
                              <button
                                className="btn btn-danger waves-effect waves-light font-size-18 w-100"
                                // style={{ height: "42px" }}
                                onClick={updateGiftCardEditable}
                              >
                                {props.t("Next Step")}
                              </button>
                            </Col>
                          </Row>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <Modal
          isOpen={modal_song}
          toggle={() => {
            tog_song()
          }}
        >
          <div className="modal-header">
            <span className="modal-title mt-0" id="myModalLabel">
              {props.t("Choose a music")}
            </span>
            <button
              type="button"
              onClick={() => {
                tog_song()
              }}
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            {musicData &&
              musicData.map((data, index) => (
                <Row>
                  <Col>
                    <Card
                      className="mb-0 shadow-none"
                      style={{
                        borderRadius: "0",
                        borderBottom: "1px",
                        borderBottomColor: "#D6D6D6",
                        borderBottomStyle: "solid",
                      }}
                      onClick={() => {
                        setSongSelected(data.id)
                      }}
                    >
                      <Row className="p-3">
                        <Col xs="auto">
                          {
                            <div className="avatar-xs mx-auto">
                              <span
                                className={
                                  "avatar-title rounded-circle bg-primary text-white font-size-16"
                                }
                                onClick={() => {
                                  if (playing && songPlaying == data.id)
                                    toggle()
                                  else {
                                    setSongPlaying(data.id)
                                    updateAudio(data.url)
                                  }
                                }}
                              >
                                <i
                                  className={
                                    playing && songPlaying == data.id
                                      ? "bx bx-pause align-middle font-size-20 text-white"
                                      : "bx bx-play align-middle font-size-20 text-white"
                                  }
                                />
                              </span>
                            </div>
                          }
                          {/* <div className="avatar-xs mx-auto">
                                    <img
                                      src={data.friend_profile_picture}
                                      className="rounded-circle avatar-xs"
                                      alt=""
                                    />
                                  </div> */}
                        </Col>
                        <Col
                          className="align-self-center"
                          onClick={() => {
                            setSongSelected(data.id)
                          }}
                        >
                          <span className="font-size-15 text-dark">
                            {data.name}
                          </span>
                        </Col>
                        {songSelected != 0 && songSelected == data.id && (
                          <Col xs="auto">
                            <span className="font-size-15">
                              <i className="bx bx-comment-check align-middle font-size-20 text-dark" />
                            </span>
                          </Col>
                        )}
                      </Row>
                    </Card>
                  </Col>
                </Row>
              ))}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              onClick={() => {
                tog_song()
              }}
              className="btn btn-secondary waves-effect"
              data-dismiss="modal"
            >
              {props.t("OK")}
            </button>
            {/* <button
            type="button"
            className="btn btn-primary waves-effect waves-light"
          >
            Save changes
          </button> */}
          </div>
        </Modal>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(CheckoutConfirmation)

CheckoutConfirmation.propTypes = {
  t: PropTypes.any,
}
